import React, { useContext, useEffect, useState } from "react";
import SuccessModal from "../../../components/common/SuccessModal";
import {
  GetUserRoleModel,
  UpdatePermission,
} from "../../../services/UserRole/UserRoleAPI";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";

const UserDefaultAccess = ({ show, onHide, setReceivedAmtObj, onConfirm }) => {
  const [showSuccessPopupModal, setSuccessPopupModal] = useState(false);
  const [actionMassage, setActionMassage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [defaultData, setDefaultData] = useState();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [checkbox, setCheckBox] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [accessCount, setAccessCount] = useState(null);
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);

  const [modelRequestData, setModelRequestData] = useState({
    status: null,
    Action: "",
  });
  const [RoleTypeIndex, setRoleTypeIndex] = useState(null);

  useEffect(() => {
    GetUserRoleModalData();
  }, []);
  useEffect(() => {
    if (isAddUpdateDone) {
      GetUserRoleModalData();
    }
    setIsAddUpdateDone(false);
  }, [isAddUpdateDone]);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  //   Get user role list API

  const GetUserRoleModalData = async (id) => {
    setLoader(true);
    // if (id === undefined) {
    //   return;
    // }

    try {
      const response = await GetUserRoleModel();
      if (response?.data?.statusCode === 200) {
        // setLoader(false);
        const AccessData =
          response?.data?.responseData?.data?.roleTypePermissions;
        setLoader(false);
        setDefaultData(AccessData);
      } else {
        // Handle non-200 status codes if necessary
        console.error("Error fetching data: ", response?.data?.statusCode);
        const errorMessage =
          response?.response?.data?.errorMessage || "An error occurred";
        setErrorMessage(errorMessage);
        // setLoader(false);
      }
    } catch (error) {
      console.error("Error in fetching GetEmployeeModel: ", error);
      // setLoader(false);
    }
  };

  // const handleUpdateBtnClicked = () => {};

  const handleUpdateBtnClicked = async () => {

    const roleTypeActionList = [];
    let allActionsUnselected = true;
    defaultData?.forEach((role) => {
      const mActionList = [];
      role.modules?.forEach((module) => {
        module.moduleActions?.forEach((action) => {
          if (action.setDefaultAction) {
            mActionList.push({ mActionId: action.mActionId });
            allActionsUnselected = false;
          }
        });
      });
      if (mActionList.length > 0) {
        roleTypeActionList.push({
          roleTypeID: role.roleTypeID,
          mActionList: mActionList,
        });
      }
    });
    // Set access count based on whether any action is selected
    const newAccessCount = allActionsUnselected ? 0 : 1;
    // Update accessCount state
    setAccessCount(newAccessCount);
    if (roleTypeActionList?.length <= 0) {
      setErrorMessage("Select at least one permission");
      return;
    }
    setLoader(true);

    // Store accessCount in local storage
    localStorage.setItem("accessCount", newAccessCount);
    try {
      const data = await UpdatePermission({
        userKeyID: authDetails.userKeyID,
        roleTypeActionList: roleTypeActionList,
      });
      if (data?.data?.statusCode === 200) {
        console.log("Data", data);
        setLoader(false);
        setIsAddUpdateDone(true);
        setActionMassage("Permission assigned successfully.");
        setSuccessPopupModal(true);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleSuccessHide = () => {
    setSuccessPopupModal(false);
    setErrorMessage("");
    setDefaultData();
    onHide();
  };

  const handleCheckAllModules = (roleIndex, e) => {
    const checked = e.target.checked;
    const role = defaultData[roleIndex];

    const data = [...defaultData];

    if (!checked) {
      setModelRequestData((prevState) => ({
        ...prevState,
        Action: "AccessModel",
      }));
      setRoleTypeIndex(roleIndex);

      data[roleIndex].modules.forEach((module) => {
        const shouldSkip =
          role.roleTypeID === 1 &&
          (module.moduleName === "Set Default Access" ||
            module.moduleName === "RoleType");

        if (shouldSkip) return;

        module.moduleActions.forEach(
          (action) => (action.setDefaultAction = false)
        );
      });
    } else {
      data[roleIndex].modules.forEach((module) => {
        const shouldSkip =
          role.roleTypeID === 1 &&
          (module.moduleName === "Set Default Access" ||
            module.moduleName === "RoleType");

        if (shouldSkip) return;

        module.moduleActions.forEach(
          (action) => (action.setDefaultAction = true)
        );
      });
    }

    setCheckBox(data);
  };


  console.log("checkbox", checkbox);

  const areAllModulesChecked = (roleIndex) => {
    const modules = defaultData[roleIndex].modules;

    return modules
      .filter(
        (module) =>
          !(
            defaultData[roleIndex]?.roleTypeID === 1 &&
            (module.moduleName === "Set Default Access" ||
              module.moduleName === "RoleType")
          )
      )
      .every((module) =>
        module.moduleActions.every((action) => action.setDefaultAction)
      );
  };


  const handleCheckAllActionsInModule = (roleIndex, moduleIndex, e) => {
    const checked = e.target.checked;
    const data = [...defaultData];

    data[roleIndex].modules[moduleIndex].moduleActions.forEach(
      (action) => (action.setDefaultAction = checked)
    );
    setErrorMessage("");
    setCheckBox(data);
  };

  const handleCheckboxChange = (
    roleIndex,
    moduleIndex,
    moduleActionIndex,
    e
  ) => {
    let checked = e.target.checked;
    let data = [...defaultData];

    const moduleActions = data[roleIndex].modules[moduleIndex].moduleActions;
    const currentAction = moduleActions[moduleActionIndex];
    const actionName = currentAction.mActionName;

    // Prevent unchecking "Can View" if "Insert" or "Update" is still checked
    if (actionName === "Can View" && !checked) {
      const insertChecked = moduleActions.find(
        (a) => a.mActionName === "Can Insert"
      )?.setDefaultAction;
      const updateChecked = moduleActions.find(
        (a) => a.mActionName === "Can Update"
      )?.setDefaultAction;

      if (insertChecked || updateChecked) {
        return; // Do nothing — block unchecking "Can View"
      }
    }

    // Set the current checkbox
    currentAction.setDefaultAction = checked;

    // If "Can Insert" or "Can Update" is checked, force-check "Can View"
    if (
      (actionName === "Can Insert" || actionName === "Can Update") &&
      checked
    ) {
      const viewAction = moduleActions.find(
        (action) => action.mActionName === "Can View"
      );
      if (viewAction) {
        viewAction.setDefaultAction = true;
      }
    }

    setErrorMessage("");
    setCheckBox(data);
  };

  const areAllActionsChecked = (roleIndex, moduleIndex) => {
    const moduleActions =
      defaultData[roleIndex].modules[moduleIndex].moduleActions;
    return moduleActions.every((action) => action.setDefaultAction);
  };

  console.log(defaultData);

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        aria-hidden={!show}
      >
        <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-xl mx-auto flex flex-col">
          {/* Modal Header */}
          <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
            {/* Title */}
            <h2 className="text-lg font-bold text-gray-700">
              Update Set Default Access
            </h2>

            {/* Close Button */}
            <button
              className="text-gray-500 hover:text-gray-800"
              onClick={onHide}
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Scrollable Content */}
          <div
            className="container mx-auto p-5 overflow-y-auto flex-grow"
            style={{ maxHeight: "60vh" }}
          >
            {defaultData?.sort((a, b) => a.roleTypeName.localeCompare(b.roleTypeName))?.map((role, roleIndex) => (
              <div key={role.roleTypeID}>
                <h2 className="" id={role.roleTypeID}>
                  <button
                    className="w-full text-left px-4 py-2 bg-gray-100 border-b flex justify-between items-center"
                    type="button"
                    onClick={() => toggleDropdown(role?.roleTypeID)}
                  >
                    <span>{role?.roleTypeName}</span>
                    <i
                      className={`fas ${openDropdown === role.roleTypeID
                        ? "fa-chevron-up"
                        : "fa-chevron-down"
                        } text-gray-700`}
                    ></i>
                  </button>
                </h2>

                {openDropdown === role?.roleTypeID && (
                  <div className="p-4 bg-white border border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center space-x-2">
                        <input
                          className="form-checkbox h-4 w-4 text-blue-500"
                          type="checkbox"
                          id={`roleIndex${roleIndex}`}
                          onChange={(e) => handleCheckAllModules(roleIndex, e)}
                          checked={areAllModulesChecked(roleIndex)} // Ensure this function correctly checks if all actions are selected
                        />

                        <label
                          htmlFor={`roleIndex${roleIndex}`}
                          className="text-sm"
                        >
                          {areAllModulesChecked(roleIndex) ? (
                            <span>
                              Unselect all{" "}
                              <b className="text-xs">{role?.roleTypeName}</b>{" "}
                              Modules
                            </span>
                          ) : (
                            <span>
                              Select all{" "}
                              <b className="text-xs">{role?.roleTypeName}</b>{" "}
                              Modules
                            </span>
                          )}
                        </label>
                      </div>

                      {role?.modules.map((module, moduleIndex) => (
                        <div
                          className="bg-gray-50 p-4 rounded-lg shadow-md"
                          key={module?.moduleId}
                        >
                          <h4 className="text-blue-500 text-sm font-semibold flex items-center">
                            <input
                              className="form-checkbox h-4 w-4 text-blue-500"
                              type="checkbox"
                              disabled={role?.roleTypeID === 1 && (module?.moduleName === 'Set Default Access' || module?.moduleName === 'RoleType')}
                              id={`role${moduleIndex}`}
                              onChange={(e) =>
                                handleCheckAllActionsInModule(
                                  roleIndex,
                                  moduleIndex,
                                  e
                                )
                              }
                              checked={areAllActionsChecked(
                                roleIndex,
                                moduleIndex
                              )}
                            />
                            <label
                              className="ml-2"
                              htmlFor={`role${moduleIndex}`}
                            >
                              {module?.moduleName}
                            </label>
                          </h4>
                          <div className="mt-2">
                            {module?.moduleActions.map(
                              (action, moduleActionIndex) => (
                                <div
                                  className="flex items-center space-x-2 mt-2"
                                  key={action?.mActionId}
                                >
                                  <input
                                    type="checkbox"

                                    id={`checkbox_${action?.mActionId}`}
                                    checked={action?.setDefaultAction}
                                    disabled={
                                      action?.mActionName === "Can View" &&
                                      module.moduleActions.some(
                                        (a) =>
                                          (a.mActionName === "Can Insert" ||
                                            a.mActionName === "Can Update") &&
                                          a.setDefaultAction
                                      ) || (role?.roleTypeID === 1 && (module?.moduleName === 'Set Default Access' || module?.moduleName === 'RoleType'))
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        roleIndex,
                                        moduleIndex,
                                        moduleActionIndex,
                                        e
                                      )
                                    }
                                  />

                                  <label
                                    className="text-sm"
                                    htmlFor={`checkbox_${action?.mActionId}`}
                                  >
                                    {action?.mActionName === "Can Delete"
                                      ? "Can Delete / Change Status / Is Default"
                                      : action?.mActionName}
                                  </label>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          {/* Dropdowns */}
          {/* {["Admin", "Sales", "Marketing", "Field", "Site HR"].map(
            (role, index) => (
              <div key={index} className="border-b last:border-b-0">
                <button
                  onClick={() => toggleDropdown(index)}
                  className="w-full flex justify-between items-center px-4 py-2 text-left"
                >
                  <span>{role}</span>
                  <span>{openDropdown === index ? "▲" : "▼"}</span>
                </button>
                {openDropdown === index && (
                  <div className="p-4 bg-gray-100">
                    <div className="">
                      <input type="checkbox" />
                      <label>Admin label</label>
                    </div>
                  </div>
                )}
              </div>
            )
          )} */}

          {/* Modal Footer */}
          {errorMessage !== null &&
            errorMessage !== undefined &&
            errorMessage !== "" ? (
            <div style={{ display: "block", textAlign: "center" }}>
              <span style={{ color: "red" }}>{errorMessage}</span>
            </div>
          ) : (
            ""
          )}
          <div className="flex justify-center gap-4 p-4 border-t sticky bottom-0 bg-white z-25">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              onClick={onHide}
            >
              Cancel
            </button>
            <button
              className="bg-blue-500 text-white rounded-md px-3 py-1 text-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              onClick={handleUpdateBtnClicked}
            >
              Update
            </button>
          </div>
        </div>
      </div>
      {showSuccessPopupModal && (
        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={handleSuccessHide}
          actionMassage={actionMassage}
        />
      )}
    </>
  );
};

export default UserDefaultAccess;
